import {registerModels} from "@danhoss/model/factory/registerModels";
import {ProductModel} from './models/ProductModel';
import {CategoryModel} from './models/CategoryModel';
import {CartModel} from './models/CartModel';
import {CartItemModel} from './models/CartItemModel';
import {UserModel} from './models/UserModel';
import {MiniRecommendedModel} from './models/MiniRecommendedModel';
import {AdditionalProductsModel} from './models/AdditionalProductsModel';

const models = {
    UserModel: UserModel,
    ProductModel: ProductModel,
    CategoryModel: CategoryModel,
    CartModel: CartModel,
    CartItemModel: CartItemModel,
    MiniRecommendedModel: MiniRecommendedModel,
    AdditionalProductsModel: AdditionalProductsModel
};

registerModels(models);

//;
